module.exports = __webpack_public_path__ + "static/media/chief-Fun.cc65ed9f.png";